import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';
import { APBillResultDto } from '../../_models/accounts-payable/ap-bill/ap-bill-result-dto';
import { TransactionLogResultDto } from '../../_models/common/transaction-log-result-dto';
import { APServiceChargeEditorResultDto } from '../../_models/accounts-payable/service-charge/ap-service-charge-editor-result-dto';
import { GLSubcategorySelectorResultDto } from '../../_models/common/gl-account/glsubcategory-selector-result-dto';
import { ReverseEditorResultDto } from '../../../../../app/shared-module/_models/reverse-editor-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class APBillService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getAPBillDetails(param) {
        const url = URLConstants.ccCBAPBillApiUrl + `/detail${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(APBillResultDto, response)));
    }
    getAPBillTransactionLog(baseParam) {
        const url = `${URLConstants.ccCBAPBillApiUrl}/history${baseParam.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(TransactionLogResultDto, response)));
    }
    reverseAPBill(baseParam) {
        return this.httpClient
            .put(`${URLConstants.ccCBAPBillApiUrl}/reverse`, classToPlain(baseParam))
            .pipe(map((responseData) => responseData));
    }
    getAPBillReverseEditor(params) {
        const url = URLConstants.ccCBAPBillApiUrl + `/reverse/editor${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain) => plainToClass(ReverseEditorResultDto, plain)));
    }
    getServiceChargeEditor(param) {
        const url = `${URLConstants.ccCBAPBillApiUrl}/servicecharge/editor${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(APServiceChargeEditorResultDto, response)));
    }
    addServiceCharge(param) {
        const url = `${URLConstants.ccCBAPBillApiUrl}/servicecharge`;
        return this.httpClient.post(url, classToPlain(param));
    }
    getServiceChargeEditorSubcategories(params) {
        const url = `${URLConstants.ccCBAPBillApiUrl}/subcategories${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(GLSubcategorySelectorResultDto, response)));
    }
    deleteAPBill(baseParam) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: classToPlain(baseParam)
        };
        return this.httpClient.delete(URLConstants.ccCBAPBillApiUrl, options);
    }
}
APBillService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function APBillService_Factory() { return new APBillService(i0.ɵɵinject(i1.HttpClient)); }, token: APBillService, providedIn: "root" });
